import InputMask from "react-input-mask"
import TextField from "@mui/material/TextField";
import { useState } from "react";

interface IMaskInput {
    mask: string;
    id: string;
    label: string;
    handle?: (value: string) => void;
}


export const MaskInput = (prop: IMaskInput) => {
    const [value, setValue] = useState('')
    const handleChange = (e: any) => {
        setValue(e.target.value)
        if (prop.handle) {
            prop.handle(e.target.value)
        }
    }

    return(
        
        <InputMask
            mask={prop.mask}
            onChange={(e) => handleChange(e)}
        >
        {           
        //@ts-ignore
       
         () => (<TextField 
                sx={{width: 260, my: 1}}
                id={prop.id}
                label={prop.label} 
                variant="standard"
                color="secondary"
                size='medium'
             />)
        }
        </InputMask>
    )
}